import { Box, Link, styled, Typography } from '@mui/material';
import { File } from 'api/v3/aas_core_meta/types';
import { messages } from 'i18n/localization';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getSanitizedHref } from 'util/HrefUtil';
import { isValidUrl } from 'util/UrlUtil';
import { useAsyncEffect } from 'hooks/UseAsyncEffect';
import { submodelClient } from 'api';

const StyledFileImg = styled('img')(() => ({
    objectFit: 'contain',
    objectPosition: 'left top',
    maxWidth: '100%',
    maxHeight: '300px',
}));

type FileComponentProps = {
    readonly file: File;
    readonly submodelId?: string;
    readonly submodelElementPath?: string;
};

export function FileComponent(props: FileComponentProps) {
    const [image, setImage] = useState<string | null>(null);
    const { file } = props;

    async function getImage() {
        if (file.contentType?.startsWith('image')) {
            if (isValidUrl(file.value)) {
                setImage(file.value);
            } else if (props.submodelId && props.submodelElementPath) {
                try {
                    const image = await submodelClient.getAttachmentFromSubmodelElement(props.submodelId, props.submodelElementPath);
                    const imageObjectURL = URL.createObjectURL(image);
                    setImage(imageObjectURL);
                } catch (e) {
                    console.error('Image not found', e)
                }
            }
        }
    }

    useAsyncEffect(async () => {
        await getImage();
    }, []);

    if (!file) {
        return <></>;
    }

    if (image) {
        return (
            <Box>
                <StyledFileImg src={image} />
            </Box>
        );
    } else {
        return file.value ? (
            <Link href={getSanitizedHref(file.value?.toString())} target="_blank">
                <Typography>{file.value?.toString()}</Typography>
            </Link>
        ) : (
            <Typography>
                <FormattedMessage {...messages.mnestix.notAvailable} />
            </Typography>
        );
    }
}
